<script setup lang="ts">
import { ref, watch } from 'vue'

const props = withDefaults(
  defineProps<{
    src?: string | null
    initials?: string
    /** Tailwind size classes, so the caller controls the scale. */
    sizeClass?: string
  }>(),
  { src: null, initials: '?', sizeClass: 'h-9 w-9 text-xs' },
)

// A remote avatar can 404: fall back to the monogram instead of a broken image.
const failed = ref(false)
watch(
  () => props.src,
  () => {
    failed.value = false
  },
)
</script>

<template>
  <span
    class="border-gold-500/60 from-primary-600 to-primary-800 inline-flex items-center justify-center overflow-hidden rounded-full border bg-gradient-to-b font-semibold text-white"
    :class="sizeClass"
  >
    <img
      v-if="src && !failed"
      :src="src"
      alt=""
      class="h-full w-full object-cover"
      loading="lazy"
      decoding="async"
      @error="failed = true"
    />
    <span v-else>{{ initials }}</span>
  </span>
</template>
